import React from 'react';
import { View, Text, StyleSheet, ViewStyle } from 'react-native';
import { useThemeColors } from '@/hooks/residents/useThemeColors';
import { CloseButton } from '@/components/shared/redesign';
import { useResponsive } from '@/hooks/common/useResponsive';

interface ModalHeaderProps {
  title?: string;
  subtitle?: string;
  onClose: () => void;
  centerTitle?: boolean;
  headerRight?: React.ReactNode;
  style?: ViewStyle;
}

export const ModalHeader: React.FC<ModalHeaderProps> = ({
  title,
  subtitle,
  onClose,
  centerTitle = false,
  headerRight,
  style,
}) => {
  const { colors } = useThemeColors();
  const { layoutMode } = useResponsive();
  const isDesktop = layoutMode === 'desktop';

  return (
    <View style={[styles.header, { borderBottomColor: colors.separator }, isDesktop && styles.headerDesktop, style]}>
      {centerTitle && <View style={styles.centerSpacer} />}
      {title ? (
        <View style={subtitle ? styles.titleContainer : styles.titleFlex}>
          <Text style={[styles.title, { color: colors.text.primary }, centerTitle && styles.titleCentered]}>
            {title}
          </Text>
          {subtitle && <Text style={[styles.subtitle, { color: colors.text.muted }]}>{subtitle}</Text>}
        </View>
      ) : (
        <View style={styles.titleFlex} />
      )}
      <View style={styles.rightSection}>
        {headerRight}
        <CloseButton onPress={onClose} color={colors.text.muted} />
      </View>
    </View>
  );
};

const styles = StyleSheet.create({
  header: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    paddingHorizontal: 24,
    paddingVertical: 20,
    borderBottomWidth: 1,
  },
  headerDesktop: {
    paddingHorizontal: 32,
    paddingVertical: 24,
  },
  centerSpacer: {
    width: 40,
  },
  titleContainer: {
    flex: 1,
    gap: 4,
  },
  titleFlex: {
    flex: 1,
  },
  title: {
    fontSize: 18,
    fontWeight: '600',
    lineHeight: 27,
  },
  titleCentered: {
    textAlign: 'center',
  },
  subtitle: {
    fontSize: 12,
    fontWeight: '300',
    lineHeight: 18,
  },
  rightSection: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: 16,
  },
});
